module.exports = __webpack_public_path__ + "static/media/winter-vaccines-news.a8510dbf.jpg";